<template>
      <div id="summary-options-current">
            <section class="section summary-hero animate__animated animate__fadeIn">
                  <BackButton link="/plan-options-current" />
                  <div class="grid-container max">
                        <div class="summary-hero-content">
                              <h1>You&rsquo;re almost done</h1>
                              <p class="summary-lead">Thanks for taking the time to go through these steps to determine the best plan for you.</p>
                              <p class="summary-plan">Your suggested plan: <strong>{{ planSelect }}</strong></p>
                              <p class="summary-desc">Now that you know your Anthem plan, you can download/email the suggested plan name as a reminder, or go directly to <a href="https://myshbpga.adp.com/" target="_blank" @click="track('Link', 'myshbpga.adp.com - Summary Options Current')">https://myshbpga.adp.com/</a> to enroll during this year&rsquo;s Open Enrollment selection period, <strong>October 19 &ndash; November 6, 2026.</strong></p>
                        </div>
                  </div>
                  <div class="summary-hero-btn-wrap">
                        <button class="summary-hero-btn" @click="checkDate()">Enroll</button>
                        <a :href="planDownload" target="_blank" class="summary-hero-btn" @click="track('CTA', 'Download OE Guide - Summary Options Current')">Download</a>
                  </div>
            </section>
      </div>
</template>

<script>
      import BackButton from "../components/BackButton"
      import gaEventMixin from "../mixins/gaEventMixin"
      export default {
            name: "SHBPSummaryOptions",
            data (){
                  return{
                        planSelect: this.$store.state.planSelect,
                        getStartedURL:"https://myshbpga.adp.com/",
                        planDownload:"",
                        popMessage: "<h5 style='font-weight:600;font-size: 1.125rem;'>Open Enrollment starts October 19, 2026</h5> <p style='margin-bottom:8px !important;'>You can't enroll in your suggested plan yet, but go to <a href='https://myshbpga.adp.com' target='_blank' id='popLink'>myshbpga.adp.com</a>  to review your suggested plan costs. You'll also find additional information and valuable resources about how to get the most out of your plan options. Be sure to come back, starting October 19, 2026 to enroll in your suggested plan.</p>"
                  }
            },
            methods:{
                  checkDate(){
                        let enrollDate = "2026-10-19",
                              currentDate = new Date()
                              enrollDate = new Date(enrollDate)
                        if(enrollDate > currentDate){
                              this.$swal({
                                    html: this.popMessage,
                                    showCancelButton: false
                              })
                              this.track('CTA', 'No Open Enrollment - Summary Options Current')
                        }
                        else{
                              this.track('CTA', 'Yes Open Enrollment - Summary Options Current')
                              window.open( this.getStartedURL, "_blank")
                        }
                  },
                  download(){
                        let planSelect = this.planSelect
                        if(planSelect=="HMO") this.planDownload = "/docs/OE-Guide-27.pdf"
                        else if(planSelect=="HRA Gold") this.planDownload = "/docs/OE-Guide-27.pdf"
                        else if(planSelect=="HRA Silver") this.planDownload =  "/docs/OE-Guide-27.pdf"
                        else if(planSelect=="HRA Bronze") this.planDownload =  "/docs/OE-Guide-27.pdf"
                        else this.planDownload =  "/docs/OE-Guide-27.pdf"
                  },
                  someMethod(e) {
                        e.preventDefault();
                        this.track("Link", "myshbpga.adp.com - Pop Up Window - Summary Options Current")
                        window.open( this.getStartedURL, "_blank")
                  },
            },
            beforeMount(){
                  this.download()
            },
            mounted() {
                  window.scrollTo(0, 0)
            },
            components: {
                  BackButton
            },
            mixins: [gaEventMixin]
      }
</script>

<style lang="scss">
#summary-options-current {
      .summary-hero {
            background-color: #1355E9;
            margin-top: 68px;
            padding: 120px 24px 140px 24px;
            position: relative;
            min-height: calc(100vh - 68px);
            display: flex;
            flex-direction: column;
            justify-content: center;

            .back-btn {
                  left: 86px;
                  border-color: #ffffff;

                  &::before {
                        background-image: none;
                        background-color: #ffffff;
                        filter: none;
                        -webkit-mask-image: url("~@/assets/img/arrow-left-icon.png");
                        mask-image: url("~@/assets/img/arrow-left-icon.png");
                        -webkit-mask-size: 15px 13px;
                        mask-size: 15px 13px;
                        -webkit-mask-repeat: no-repeat;
                        mask-repeat: no-repeat;
                        -webkit-mask-position: center;
                        mask-position: center;
                  }
            }

            .grid-container.max {
                  width: 100%;
                  max-width: 85rem !important;
            }

            .summary-hero-content {
                  max-width: 760px;
                  margin: 0 auto;
                  text-align: center;

                  h1 {
                        color: #ffffff;
                        font-size: clamp(3rem, 6vw, 5.5rem) !important;
                        font-weight: 600;
                        line-height: 1 !important;
                        margin-bottom: 32px;
                  }

                  .summary-lead {
                        color: #ffffff;
                        font-size: 1.375rem;
                        font-weight: 500;
                        line-height: 1.4;
                        margin-bottom: 24px;
                  }

                  .summary-plan {
                        color: #ffffff;
                        font-size: 1.125rem;
                        font-weight: 400;
                        margin-bottom: 24px;

                        strong {
                              font-weight: 700;
                        }
                  }

                  .summary-desc {
                        color: rgba(255, 255, 255, 0.9);
                        font-size: 1rem;
                        font-weight: 400;
                        line-height: 1.6;
                        margin-bottom: 0;

                        a {
                              color: #ffffff !important;
                              font-weight: 700;
                              text-decoration: underline;
                        }

                        strong {
                              font-weight: 700;
                              color: #ffffff;
                        }
                  }
            }

            .summary-hero-btn-wrap {
                  position: fixed;
                  left: 0;
                  right: 0;
                  bottom: 0;
                  z-index: 3;
                  padding: 32px 24px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  gap: 24px;
            }

            .summary-hero-btn {
                  display: block;
                  background-color: #ffffff;
                  color: #1355E9 !important;
                  font-weight: 700;
                  text-transform: uppercase;
                  font-size: 1rem;
                  padding: 18px 0;
                  width: 100%;
                  max-width: 280px;
                  text-align: center;
                  border-radius: 30px;
                  border: none;
                  cursor: pointer;

                  &:hover {
                        opacity: 0.85;
                  }
            }

            @media only screen and (max-width: 959px) {
                  padding: 96px 24px 40px 24px;
                  justify-content: flex-start;

                  .back-btn {
                        left: 2rem;
                  }

                  .summary-hero-content {
                        text-align: left;

                        h1 {
                              font-size: clamp(1.5rem, 8.5vw, 5.5rem) !important;
                              white-space: nowrap;
                        }
                  }

                  .summary-hero-btn-wrap {
                        position: static;
                        flex-direction: column;
                        gap: 16px;
                        padding: 40px 0 0 0;
                  }

                  .summary-hero-btn {
                        max-width: 100%;
                  }
            }
      }
}
</style>
